/* eslint-disable security/detect-object-injection */
import React, { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTrail, animated } from 'react-spring';
import { setLocale } from 'store/app/actions';
import { Locale } from 'store/app/types';
import { InteractiveList } from 'components/InteractiveList';
import { AnimatedHeader } from 'components/AnimatedHeader';
import SV from '../../assets/sv.svg';
import US from '../../assets/en.svg';

interface Props {
    navLinks: any[];
}

export const Navigation: React.FC<Props> = ({ navLinks }: { navLinks: any }) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const handleLocaleChange = useCallback(
        (e: React.FormEvent<HTMLButtonElement>) => {
            dispatch(setLocale(e.currentTarget.value as Locale));
        },
        [dispatch]
    );
    const [langToggle, setLangToggle] = useState(false);
    const [buttonTraverse, setButtonTraverse] = useState(-148);
    const supportedLangs = Object.keys(i18n.options.resources!);
    const langTrail = useTrail(supportedLangs.length, {
        from: { opacity: 0, x: 10, height: 0 },
        to: {
            opacity: langToggle ? 1 : 0,
            x: langToggle ? 0 : 10,
            height: langToggle ? 80 : 0,
        },
        reverse: !langToggle,
    });
    useEffect(() => {
        setButtonTraverse(i18n.language === 'en_US' ? -164 : -148);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    return (
        <nav className="am_nav_bar" onMouseLeave={() => setLangToggle(false)}>
            {navLinks.map((item: any, key: any) => (
                <Link
                    key={key}
                    to={item.route === '/franchise' || item.route === '/koncept' ? '' : item.route}
                    style={{
                        pointerEvents:
                            item.route === '/franchise' || item.route === '/koncept'
                                ? 'none'
                                : 'auto',
                        color:
                            item.route === '/franchise' || item.route === '/koncept'
                                ? '#8898aa'
                                : '#000000',
                    }}
                >
                    <InteractiveList
                        text={t(item.text)}
                        name={item.route}
                        col={['#000000', '#000000']}
                    />
                </Link>
            ))}
            <div className="am_nav_lang_current">
                <button
                    value={i18n.language}
                    onClick={() => setLangToggle((langToggle) => !langToggle)}
                >
                    {i18n.language === 'sv_SV' ? (
                        <span>
                            <img src={SV} alt="SV" />
                        </span>
                    ) : (
                        <span>
                            <img src={US} alt="EN" />
                        </span>
                    )}
                </button>
                {langTrail.map(({ x, height, ...rest }, index) => (
                    <animated.div
                        key={supportedLangs[index]}
                        className="am_nav_select_lang"
                        style={{
                            ...rest,
                            transform: x.interpolate((x) => `translate3d(0,${x}px,0)`),
                        }}
                    >
                        {i18n.language !== supportedLangs[index] && (
                            <animated.button
                                style={
                                    langToggle
                                        ? { pointerEvents: 'all' }
                                        : { pointerEvents: 'none' }
                                }
                                value={supportedLangs[index]}
                                onClick={handleLocaleChange}
                            >
                                <span>
                                    <img src={supportedLangs[index] === 'en_US' ? US : SV} />
                                </span>
                            </animated.button>
                        )}
                    </animated.div>
                ))}
            </div>
            <Link className="am_franchise_link" to={''}>
                <button className="am_franchise_button">
                    <AnimatedHeader message={t('nav.button')} len={buttonTraverse} dur={5} />
                </button>
            </Link>
        </nav>
    );
};
